// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zHOO","title":"Header_title__13SER","left":"Header_left__3WM8c","clinicName":"Header_clinicName__1nSKo"};